import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api.magnirauniverse.com";

const API = `${BASE_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const fileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;

  return `${BASE_URL}${url}`;
};